import * as actionTypes from 'containers/PageHeader/action-types';
import moment from 'moment';
import { FilterType, GlobalFilterKey } from 'utils/types';
import { PERIOD_DATE_SET } from 'containers/AccessControl/actionTypes';

export interface PagesFilters<T> {
  [key: string]: T;
}

export type StateType = {
  readonly endWeek: string;
  readonly pagesFilters: PagesFilters<FilterType>;
  readonly weeks: number;
};

export const createEmptyFilter = (): FilterType => {
  return {
    accounts: [],
    items: [],
    states: [],
    stores: []
  };
};

const initialState: StateType = {
  endWeek: moment().format('YYYY-MM-DD'),
  weeks: 12,
  pagesFilters: {
    [GlobalFilterKey.GLOBAL]: createEmptyFilter(),
    [GlobalFilterKey.DETAILS]: createEmptyFilter()
  }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PERIOD_DATE_SET:
      // When spins/nielsen dates are setted, update filter endWeek
      return {
        ...state,
        endWeek: action.payload.spins ? action.payload.spins : action.payload.nielsen
      };
    case actionTypes.GLOBAL_FILTER_CLEAR:
      return {
        ...state,
        pagesFilters: {
          ...state.pagesFilters,
          [action.payload]: createEmptyFilter()
        }
      };
    case actionTypes.GLOBAL_FILTER_FOR_TYPE_CLEAR:
      return {
        ...state,
        pagesFilters: {
          ...state.pagesFilters,
          [action.payload.globalFilterKey]: {
            ...state.pagesFilters[action.payload.globalFilterKey],
            [action.payload.type]: []
          }
        }
      };
    case actionTypes.GLOBAL_FILTER_ITEM_REMOVE:
      return {
        ...state,
        pagesFilters: {
          ...state.pagesFilters,
          [action.payload.globalFilterKey]: {
            ...state.pagesFilters[action.payload.globalFilterKey],
            [action.payload.type]: state.pagesFilters[action.payload.globalFilterKey][
              action.payload.type
            ].filter(id => id !== action.payload.id)
          }
        }
      };
    case actionTypes.GLOBAL_FILTER_ARRAY_UPDATE:
      return {
        ...state,
        pagesFilters: {
          ...state.pagesFilters,
          [action.payload.globalFilterKey]: {
            ...state.pagesFilters[action.payload.globalFilterKey],
            [action.payload.arrayName]: [...action.payload.newArray]
          }
        }
      };
    case actionTypes.GLOBAL_FILTER_ARRAYS_UPDATE:
      return {
        ...state,
        pagesFilters: {
          ...state.pagesFilters,
          [action.payload.globalFilterKey]: {
            ...state.pagesFilters[action.payload.globalFilterKey],
            accounts: [...action.payload.newFilter.accounts],
            items: [...action.payload.newFilter.items],
            states: [...action.payload.newFilter.states],
            stores: [...action.payload.newFilter.stores]
          }
        }
      };
    case actionTypes.GLOBAL_FILTER_WEEKS_UPDATE:
      return {
        ...state,
        weeks: action.payload
      };
    case actionTypes.GLOBAL_FILTER_BRAND_UPDATE:
      return {
        ...state,
        brand: action.payload
      };
    default:
      return state;
  }
};

export default reducer;
